//@ts-ignore
import React from 'react';
import { Box, BoxProps, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

type Props = BoxProps & {
  icon: string;
  type?: string;
  size?: 'large' | 'medium' | 'small';
  fontSize?: string;
  color?: string;
};

export function Icon(props: Props) {
  const { icon, type = 'far', size = 'medium', color, ...rest } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Logic for responsive icon font size. Will be finished later
  const fontSize = useMemo(() => {
    if (size === 'large') {
      return isMobile ? '20px' : '30px';
    }
    if (size === 'medium') {
      return isMobile ? '20px' : '20px';
    }
    return '15px';
  }, [size, isMobile]);

  const { sx, ...other } = rest;

  return (
    <Box
      component="i"
      className={`${type} ${icon} fa-fw`}
      sx={{
        fontSize: `${props.fontSize || fontSize} !important`,
        color: color || theme.palette.common.white,
        ...sx,
      }}
      {...other}
    />
  );
}
